module.exports = __webpack_public_path__ + "static/media/event-series-accent.a50a7fac.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/event-series-accent.svg
// module id = 101
// module chunks = 0